/**
 * Sales and receivables permission keys used by the UI (catalog `sales.*` / `rpt.*` / `inv.offers_and_campaigns.*`).
 * The API checks the same keys; create, approve and post are separate (G3).
 */
export const salesPermissions = {
  quotationView: "sales.sale_quotation.view",
  orderView: "sales.sale_order.view",
  pickListView: "sales.sale_pick_and_pack.view",
  deliveryView: "sales.goods_issued.view",
  invoiceView: "sales.sale_accounting.view",
  returnView: "sales.goods_return.view",
  returnRequestView: "sales.sale_return_request.view",
  priceCreditView: "sales.tax_credit_note.view",
  salespersonView: "sales.supervisor_employees.view",
  salespersonCreate: "sales.supervisor_employees.create",
  salespersonUpdate: "sales.supervisor_employees.update",
  salespersonDelete: "sales.supervisor_employees.delete",
  customerProfileView: "sales.sales_man_managment.view",
  customerProfileUpdate: "sales.sales_man_managment.update",
  customerProfileDelete: "sales.sales_man_managment.delete",
  promotionView: "inv.offers_and_campaigns.view",
  promotionCreate: "inv.offers_and_campaigns.create",
  promotionUpdate: "inv.offers_and_campaigns.update",
  promotionDelete: "inv.offers_and_campaigns.delete",
  returnReasonView: "sales.return_reason.view",
  returnReasonCreate: "sales.return_reason.create",
  returnReasonUpdate: "sales.return_reason.update",
  returnReasonDelete: "sales.return_reason.delete",
  accountSettingsView: "sales.account_settings.view",
  accountSettingsUpdate: "sales.account_settings.update",
  settingsView: "sales.settings.view",
  settingsUpdate: "sales.settings.update",
  orderClose: "sales.sale_order.close",
  orderReserve: "sales.sale_order.reserve",
  orderOverrideCreditLimit: "sales.sale_order.override_credit_limit",
  invoiceOverrideCreditLimit: "sales.sale_accounting.override_credit_limit",
  returnRequestConvert: "sales.sale_return_request.convert",
  overridePrice: "sales.pricing.override_price",
  viewCost: "sales.pricing.view_cost",
  billingDueView: "sales.billing_due.view",
  accrualView: "sales.accrual.view",
  accrualPost: "sales.accrual.post",
  commissionView: "sales.calculation_of_commissions.view",
  commissionCalculate: "sales.calculation_of_commissions.create",
  commissionPost: "sales.calculation_of_commissions.post",
  targetView: "sales.add_target.view",
  targetCreate: "sales.add_target.create",
  targetUpdate: "sales.add_target.update",
  targetDelete: "sales.add_target.delete",
  agingView: "rpt.accounts_recivable_aging.view",
  statementView: "rpt.statement_of_account.view",
  salesAnalysisView: "rpt.sales_analysis.view",
  openOrdersView: "rpt.open_sales_orders.view",
  creditExposureView: "rpt.credit_exposure.view",
} as const;

/** Plan module of Sales (tenant entitlement); the receivables reports use `finance`. */
export const salesModule = "sales";
export const receivablesModule = "finance";
